import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import TodaysDecisions from "@/pages/TodaysDecisions";
import WeeklyReview from "@/pages/WeeklyReview";
import Accountability from "@/pages/Accountability";
import Projects from "@/pages/Projects";
import Settings from "@/pages/Settings";
import ImportEstimate from "@/pages/ImportEstimate";
import Audit from "@/pages/Audit";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="h-screen flex items-center justify-center polaris-bg">
        <span className="w-6 h-6 rounded-full border-2 border-gold border-t-transparent animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><TodaysDecisions /></Protected>} />
      <Route path="/weekly" element={<Protected><WeeklyReview /></Protected>} />
      <Route path="/accountability" element={<Protected><Accountability /></Protected>} />
      <Route path="/projects" element={<Protected><Projects /></Protected>} />
      <Route path="/import" element={<Protected><ImportEstimate /></Protected>} />
      <Route path="/audit" element={<Protected><Audit /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
